export default __webpack_public_path__ + "static/media/v_wdt_c_0.7ded5ffa.mp3";